import { parseMeta } from './parse_meta';

// This is a simple check to ensure that we don't load CASTLE IO in non-compatible
// environments (node.js + jsdom)
const hasDOM = (
  window.document &&
  window.document.domain &&
  window.document.cookie
);

if (CASTLE_IO_APP_ID && hasDOM) {
  // eslint-disable-next-line
  require('castle.js/dist/c');

  window.addEventListener('load', () => {
    const userConfig = parseMeta('current-user');

    if (window._castle) {
      window._castle('setAppId', CASTLE_IO_APP_ID);
      window._castle('autoTrack', false);
      window._castle('identify', (userConfig.user.id || userConfig.user.cookieId));
      window._castle('secure', userConfig.user.castleSignature);
      window._castle('trackPageview');
    }
  });
}



// WEBPACK FOOTER //
// ./javascripts/components/castle.js